import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, Eixo } from './types';

export const INITIAL_STATE: Eixo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Eixo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EIXO_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.EIXO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.EIXO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
